const STORAGE_KEY = 'peoplevue_saved_filters';

/**
 * Read all saved filter presets from localStorage.
 * @returns {Array<{id: string, name: string, query: string, departments: string[], offices: string[], createdAt: string}>}
 */
export function getSavedFilters() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Persist a new named filter preset.
 * @param {{ name: string, query: string, departments: string[], offices: string[] }} filter
 * @returns {{ id: string, name: string, query: string, departments: string[], offices: string[], createdAt: string }}
 */
export function saveFilter({ name, query, departments, offices }) {
  const filters = getSavedFilters();
  const newFilter = {
    id: `filter_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    name: name.trim(),
    query: query || '',
    departments: departments || [],
    offices: offices || [],
    createdAt: new Date().toISOString(),
  };
  filters.push(newFilter);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
  return newFilter;
}

/**
 * Delete a saved filter preset by id.
 * @param {string} id
 */
export function deleteFilter(id) {
  const filters = getSavedFilters().filter((f) => f.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}

/**
 * Update fields on an existing saved filter preset.
 * @param {string} id
 * @param {Partial<{name: string, query: string, departments: string[], offices: string[]}>} changes
 */
export function updateFilter(id, changes) {
  const filters = getSavedFilters().map((f) =>
    f.id === id ? { ...f, ...changes } : f
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}
